import Vue from 'vue'
import store from '@/store'
import { REMOTE_PATHS } from '@/constants/remote-paths.constant'
import requestBuilder from '@/requestBuilder'
import { OauthService } from '@/services'

function setAccessTokens (token) {
  Vue.prototype.$cookie.set('accessToken', token.accessToken, {
    expires: `${token.expiresInMillis / 1000}s`,
    domain: REMOTE_PATHS.COOKIE_DOMAIN
  })
  Vue.prototype.$cookie.set('refreshToken', token.refreshToken, {
    domain: REMOTE_PATHS.COOKIE_DOMAIN,
    expires: 1000
  })
}

/**
 * Workaround solution for REMOTE_PATHS.API_PATH
 * ending with /api on every known KCWeb environment
 * @param {string} path
 * @returns {string} path with /oauth2 ending
 */
function replaceApiWithOauth (path) {
  if (path.endsWith('/api')) {
    return path.slice(0, -4) + '/oauth2'
  } else {
    return path + '/oauth2'
  }
}

const constructBase = () => replaceApiWithOauth(REMOTE_PATHS.API_PATH)

function refreshTokenPostRequest (body) {
  return requestBuilder.post({
    path: '/token',
    body,
    base: constructBase(),
    withAuthorization: false
  })
}

export function refreshAccessToken () {
  const refreshToken = Vue.cookie.get('refreshToken')
  if (!refreshToken) {
    store.dispatch('user/logout', false)
    return Promise.reject(new Error('Refresh Token is missing'))
  }
  const body = OauthService.createTokenRequest({
    clientId: REMOTE_PATHS.OAUTH_CLIENT_ID,
    grantType: 2,
    refreshToken
  })
  return refreshTokenPostRequest(body).then(
    response => {
      const decodedTokens = OauthService.decodeTokenResponse(response.body)
      setAccessTokens(decodedTokens)
      return decodedTokens
    },
    error => Promise.reject(error)
  )
}
